import { ripple } from '@cfgtech/ui'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('ripple', {
    ...ripple(),
  })
})
